// extracted by mini-css-extract-plugin
export default {"ellipsis":"Typography_ellipsis__u6lHw"};